module.exports = "pegasus/assets/background-patterns/theme3_theme.gif";